import { SearchTerm } from "./SearchTerm";

const TourRouteSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "tourName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "area.site.siteName",
        translationKey: "site"
    }
];

export default TourRouteSearch;
